export const entries = [
	{
		'id': 'aB-zKTDZjDINyCLqhgdMK',
		'type': 'repository',
		'fakeId': 'aB-zKTDZjDINyCLqhgdMK',
		'parentId': null,
		'createdAt': '2026-02-28T12:33:57.177Z',
		'title': 'Work items',
		'singular': 'Work item',
		'rank': 0,
		'color': '#FFD93D',
		'isBookmarked': true
	},
	{
		'id': '-CPX86SrlnffwRzvpNgOq',
		'type': 'templatePropertyString',
		'fakeId': '-CPX86SrlnffwRzvpNgOq',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'createdAt': '2026-02-28T12:33:57.576Z',
		'label': 'Do',
		'slug': 'do',
		'required': true,
		'rank': 0
	},
	{
		'id': 'BaqRIjCusvFCahrQXJUWX',
		'type': 'templatePropertyText',
		'fakeId': 'BaqRIjCusvFCahrQXJUWX',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'createdAt': '2026-04-09T10:59:38.117Z',
		'label': 'Notes',
		'slug': 'additional-notes',
		'required': false,
		'rank': 8
	},
	{
		'id': 'WQsZN24NG0FywPKlpcHU4',
		'type': 'templatePropertyDate',
		'fakeId': 'WQsZN24NG0FywPKlpcHU4',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'createdAt': '2026-04-03T17:49:53.914Z',
		'label': 'Created at',
		'slug': 'created-at',
		'required': true,
		'rank': 7
	},
	{
		'id': '4CyekONzSuI33jhX4ZNtO',
		'type': 'templatePropertyBelongsTo',
		'fakeId': '4CyekONzSuI33jhX4ZNtO',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'createdAt': '2026-03-19T13:31:25.021Z',
		'label': 'Type',
		'slug': 'type',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'required': true,
		'allowMany': false,
		'rank': 1
	},
	{
		'id': 'n6umKbiRaVdZmeovJhd2A',
		'type': 'templatePropertyBelongsTo',
		'fakeId': 'n6umKbiRaVdZmeovJhd2A',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'createdAt': '2026-04-26T13:12:57.174Z',
		'label': 'Category',
		'slug': 'category',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'required': false,
		'allowMany': false,
		'rank': 3
	},
	{
		'id': '331Xn2Ka-Od7-_68wFuUH',
		'type': 'repository',
		'fakeId': '331Xn2Ka-Od7-_68wFuUH',
		'parentId': null,
		'createdAt': '2026-03-19T13:29:50.881Z',
		'title': 'Item types',
		'singular': 'Item type',
		'rank': 1,
		'color': null,
		'isBookmarked': false
	},
	{
		'id': '5tYMZ0xb7g87YKDAlZhcs',
		'type': 'templatePropertyString',
		'fakeId': '5tYMZ0xb7g87YKDAlZhcs',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'createdAt': '2026-03-19T13:29:50.928Z',
		'label': 'Name',
		'slug': 'name',
		'required': false,
		'rank': null
	},
	{
		'id': 'mDkM_1ceVGEmAypsHaIXC',
		'type': 'templatePropertyString',
		'fakeId': 'mDkM_1ceVGEmAypsHaIXC',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'createdAt': '2026-04-02T09:42:44.802Z',
		'label': 'Description',
		'slug': 'description',
		'required': false,
		'rank': null
	},
	{
		'type': 'repositoryEntry',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'id': 'MM4PaUbjACqaR8uQSAB2S',
		'fakeId': 'MM4PaUbjACqaR8uQSAB2S',
		'rank': 'a0'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': '5tYMZ0xb7g87YKDAlZhcs',
		'slug': 'name',
		'parentId': 'MM4PaUbjACqaR8uQSAB2S',
		'value': '🐞 Bug',
		'id': 'JV4rMDhQGQbW3ibQvp-Fz',
		'fakeId': 'JV4rMDhQGQbW3ibQvp-Fz'
	},
	{
		'id': 'geg-qOCWjoSskQhNU72FS',
		'type': 'repository',
		'fakeId': 'geg-qOCWjoSskQhNU72FS',
		'parentId': null,
		'createdAt': '2026-04-26T13:12:00.455Z',
		'title': 'Item categories',
		'singular': 'Item category',
		'rank': 2,
		'color': null,
		'isBookmarked': false
	},
	{
		'id': '67ji6o1Bl7DMLFxmNw0JC',
		'type': 'templatePropertyString',
		'fakeId': '67ji6o1Bl7DMLFxmNw0JC',
		'parentId': 'geg-qOCWjoSskQhNU72FS',
		'createdAt': '2026-04-26T13:12:00.680Z',
		'label': 'Name',
		'slug': 'name',
		'required': false,
		'rank': null
	},
	{
		'type': 'repositoryEntry',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'id': 'ImW3OpNTVFWadnV3Mh3X5',
		'fakeId': 'ImW3OpNTVFWadnV3Mh3X5',
		'rank': 'a2'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': '5tYMZ0xb7g87YKDAlZhcs',
		'slug': 'name',
		'parentId': 'ImW3OpNTVFWadnV3Mh3X5',
		'value': '💎 Feature',
		'id': 'u3J7eoZ7TLulkQRsuzdP_',
		'fakeId': 'u3J7eoZ7TLulkQRsuzdP_'
	},
	{
		'type': 'repositoryEntry',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'id': 'D0ygDBEeuwCgfN8wctWOS',
		'fakeId': 'D0ygDBEeuwCgfN8wctWOS',
		'rank': 'a3'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': '5tYMZ0xb7g87YKDAlZhcs',
		'slug': 'name',
		'parentId': 'D0ygDBEeuwCgfN8wctWOS',
		'value': '✨ UX improvement',
		'id': 'gccmWs5Y0CD64W1sOesyu',
		'fakeId': 'gccmWs5Y0CD64W1sOesyu'
	},
	{
		'type': 'repositoryEntry',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'id': 'eOzYkc1LjQmlpogD4fA4w',
		'fakeId': 'eOzYkc1LjQmlpogD4fA4w',
		'rank': 'a1'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': '5tYMZ0xb7g87YKDAlZhcs',
		'slug': 'name',
		'parentId': 'eOzYkc1LjQmlpogD4fA4w',
		'value': '🪖 Chore',
		'id': 'I-cRo1HJYKWSB2g_T7ODP',
		'fakeId': 'I-cRo1HJYKWSB2g_T7ODP'
	},
	{
		'parentId': 'D0ygDBEeuwCgfN8wctWOS',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': 'mDkM_1ceVGEmAypsHaIXC',
		'type': 'entryPropertyString',
		'slug': 'description',
		'value': 'Adjust the look and feel of an existing user flow',
		'id': 'DdA11iSNJbc_nOySCvjX-',
		'fakeId': 'DdA11iSNJbc_nOySCvjX-'
	},
	{
		'parentId': 'MM4PaUbjACqaR8uQSAB2S',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': 'mDkM_1ceVGEmAypsHaIXC',
		'type': 'entryPropertyString',
		'slug': 'description',
		'value': 'Unintended product behaviour impacting end user experience',
		'id': 'rcKJ-dZmboC7pSdTXD_vx',
		'fakeId': 'rcKJ-dZmboC7pSdTXD_vx'
	},
	{
		'parentId': 'eOzYkc1LjQmlpogD4fA4w',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': 'mDkM_1ceVGEmAypsHaIXC',
		'type': 'entryPropertyString',
		'slug': 'description',
		'value': 'Work that pays off in the long run. Prevent UX degradation. Mitigate risks.',
		'id': 'YyedOCfC8RrtkA9gaDCrG',
		'fakeId': 'YyedOCfC8RrtkA9gaDCrG'
	},
	{
		'parentId': 'ImW3OpNTVFWadnV3Mh3X5',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': 'mDkM_1ceVGEmAypsHaIXC',
		'type': 'entryPropertyString',
		'slug': 'description',
		'value': 'Unlocking new user flows',
		'id': 'lNeSjLOHqLHfTp0Ih3i4a',
		'fakeId': 'lNeSjLOHqLHfTp0Ih3i4a'
	},
	{
		'type': 'repositoryEntry',
		'parentId': '331Xn2Ka-Od7-_68wFuUH',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'id': 'ZYeamVHPDew48audwhnwF',
		'fakeId': 'ZYeamVHPDew48audwhnwF',
		'rank': 'a4'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': '5tYMZ0xb7g87YKDAlZhcs',
		'slug': 'name',
		'parentId': 'ZYeamVHPDew48audwhnwF',
		'value': '💡 Idea',
		'id': 'ue5DvCWJxzIRqe6d5oH3K',
		'fakeId': 'ue5DvCWJxzIRqe6d5oH3K'
	},
	{
		'parentId': 'ZYeamVHPDew48audwhnwF',
		'repositoryId': '331Xn2Ka-Od7-_68wFuUH',
		'propertyDefinitionId': 'mDkM_1ceVGEmAypsHaIXC',
		'type': 'entryPropertyString',
		'slug': 'description',
		'value': 'Needs more research',
		'id': '63XTWBhIt4NuQe5Ma_QmW',
		'fakeId': '63XTWBhIt4NuQe5Ma_QmW'
	},
	{
		'type': 'templatePropertyText',
		'label': 'Description',
		'slug': 'description',
		'required': false,
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'rank': 4,
		'id': 'yXP_M8uPIqErWfGQSDfyJ',
		'fakeId': 'yXP_M8uPIqErWfGQSDfyJ'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'geg-qOCWjoSskQhNU72FS',
		'repositoryId': 'geg-qOCWjoSskQhNU72FS',
		'id': 'n3AlJcppyun2ntI9lA78E',
		'fakeId': 'n3AlJcppyun2ntI9lA78E',
		'rank': 'Zz'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'geg-qOCWjoSskQhNU72FS',
		'propertyDefinitionId': '67ji6o1Bl7DMLFxmNw0JC',
		'slug': 'name',
		'parentId': 'n3AlJcppyun2ntI9lA78E',
		'value': '🔎 Catalog & Search',
		'id': 'BSISn0hhA7ZTSG7cAaIaM',
		'fakeId': 'BSISn0hhA7ZTSG7cAaIaM'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'geg-qOCWjoSskQhNU72FS',
		'repositoryId': 'geg-qOCWjoSskQhNU72FS',
		'id': 'hxufZmUPLlplIqJsDd56W',
		'fakeId': 'hxufZmUPLlplIqJsDd56W',
		'rank': 'Zy'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'geg-qOCWjoSskQhNU72FS',
		'propertyDefinitionId': '67ji6o1Bl7DMLFxmNw0JC',
		'slug': 'name',
		'parentId': 'hxufZmUPLlplIqJsDd56W',
		'value': '🛒 Checkout & Payments',
		'id': '8SrBePBR6HC0gcRzZfjEO',
		'fakeId': '8SrBePBR6HC0gcRzZfjEO'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'geg-qOCWjoSskQhNU72FS',
		'repositoryId': 'geg-qOCWjoSskQhNU72FS',
		'id': '2OLoNhsUQUD6Ulx0pY0fx',
		'fakeId': '2OLoNhsUQUD6Ulx0pY0fx',
		'rank': 'Zx'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'geg-qOCWjoSskQhNU72FS',
		'propertyDefinitionId': '67ji6o1Bl7DMLFxmNw0JC',
		'slug': 'name',
		'parentId': '2OLoNhsUQUD6Ulx0pY0fx',
		'value': '📦 Orders & Delivery',
		'id': 't5XF-e-JxhLLS6V8ACHQD',
		'fakeId': 't5XF-e-JxhLLS6V8ACHQD'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': 'DVlbwxLsBanZOdj5VA5A1',
		'fakeId': 'DVlbwxLsBanZOdj5VA5A1',
		'rank': 'a0l'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': 'DVlbwxLsBanZOdj5VA5A1',
		'value': 'Support Apple Pay and Google Pay',
		'id': 'KUVyrbSjVDLfiHj-h0jNa',
		'fakeId': 'KUVyrbSjVDLfiHj-h0jNa'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': 'DVlbwxLsBanZOdj5VA5A1',
		'value': 'ImW3OpNTVFWadnV3Mh3X5',
		'id': 'cit708r_3Cy6WDpCmuqaD',
		'fakeId': 'cit708r_3Cy6WDpCmuqaD',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': 'DVlbwxLsBanZOdj5VA5A1',
		'value': '2026-05-12',
		'id': '-yZ1gVbFXJF17UDtLFyOc',
		'fakeId': '-yZ1gVbFXJF17UDtLFyOc'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': 'Z0VVznV7ithG9SWP80ZUj',
		'fakeId': 'Z0VVznV7ithG9SWP80ZUj',
		'rank': 'a2'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': 'Z0VVznV7ithG9SWP80ZUj',
		'value': 'Upgrade payment provider SDK',
		'id': 'GbnHVzzfL13pGg2k0FRA_',
		'fakeId': 'GbnHVzzfL13pGg2k0FRA_'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': 'Z0VVznV7ithG9SWP80ZUj',
		'value': 'eOzYkc1LjQmlpogD4fA4w',
		'id': 'h7x7cgyVbz_Z4H8Xk8QvV',
		'fakeId': 'h7x7cgyVbz_Z4H8Xk8QvV',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': 'Z0VVznV7ithG9SWP80ZUj',
		'value': '2026-05-07',
		'id': 've970QL1CZ7gjHH_DAYd1',
		'fakeId': 've970QL1CZ7gjHH_DAYd1'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': '8Y2vKdUkRTCLskHjUtSJw',
		'fakeId': '8Y2vKdUkRTCLskHjUtSJw',
		'rank': 'a3'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': '8Y2vKdUkRTCLskHjUtSJw',
		'value': 'Allow users to select delivery time slots',
		'id': 'ZS-xlbor3bhXoc5C9Yg_T',
		'fakeId': 'ZS-xlbor3bhXoc5C9Yg_T'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': '8Y2vKdUkRTCLskHjUtSJw',
		'value': 'ImW3OpNTVFWadnV3Mh3X5',
		'id': 'Iu-BeaTle-ivYyHP6B4km',
		'fakeId': 'Iu-BeaTle-ivYyHP6B4km',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': '8Y2vKdUkRTCLskHjUtSJw',
		'value': '2026-05-07',
		'id': 'vp5LXOXXkhE1USlbu8-p3',
		'fakeId': 'vp5LXOXXkhE1USlbu8-p3'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': 'knD5uUFeHsN52IX-2c5ls',
		'fakeId': 'knD5uUFeHsN52IX-2c5ls',
		'rank': 'a4'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': 'knD5uUFeHsN52IX-2c5ls',
		'value': 'Orders occasionally duplicated on slow network connections',
		'id': 'p7jhhDmktyeGDvMLlZ-2m',
		'fakeId': 'p7jhhDmktyeGDvMLlZ-2m'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': 'knD5uUFeHsN52IX-2c5ls',
		'value': 'MM4PaUbjACqaR8uQSAB2S',
		'id': '2AKvKN9AwpVhy_MJSvBd-',
		'fakeId': '2AKvKN9AwpVhy_MJSvBd-',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': 'knD5uUFeHsN52IX-2c5ls',
		'value': '2026-05-05',
		'id': '37fsVzj2MHFhNRZhuPxT-',
		'fakeId': '37fsVzj2MHFhNRZhuPxT-'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': 'pZ0GZ5QmFzIn4bTuYjoxo',
		'fakeId': 'pZ0GZ5QmFzIn4bTuYjoxo',
		'rank': 'a5'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': 'pZ0GZ5QmFzIn4bTuYjoxo',
		'value': 'Show clearer delivery ETA on order confirmation page',
		'id': 'fVAJYybsOQwGk5GB2L_Xp',
		'fakeId': 'fVAJYybsOQwGk5GB2L_Xp'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': 'pZ0GZ5QmFzIn4bTuYjoxo',
		'value': 'D0ygDBEeuwCgfN8wctWOS',
		'id': 'aH7T7Vjb_hgXc3s7rpl3c',
		'fakeId': 'aH7T7Vjb_hgXc3s7rpl3c',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': 'pZ0GZ5QmFzIn4bTuYjoxo',
		'value': '2026-05-05',
		'id': 'ie9uyD7ESKyYME4a6Q3Nc',
		'fakeId': 'ie9uyD7ESKyYME4a6Q3Nc'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': 'FwmIG5hDhRI-frXW68gHZ',
		'fakeId': 'FwmIG5hDhRI-frXW68gHZ',
		'rank': 'a6'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': 'FwmIG5hDhRI-frXW68gHZ',
		'value': 'Migrate order service to new database cluster',
		'id': 'jXky64CVub2n3GIT0RMXI',
		'fakeId': 'jXky64CVub2n3GIT0RMXI'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': 'FwmIG5hDhRI-frXW68gHZ',
		'value': 'eOzYkc1LjQmlpogD4fA4w',
		'id': '6DzBUjtcL12d4VxiXrNn-',
		'fakeId': '6DzBUjtcL12d4VxiXrNn-',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': 'FwmIG5hDhRI-frXW68gHZ',
		'value': '2026-05-04',
		'id': 'Z4t9w1Etd7uNjtotwxMKM',
		'fakeId': 'Z4t9w1Etd7uNjtotwxMKM'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': 'TDGnRLBGCRm10pMkJatG5',
		'fakeId': 'TDGnRLBGCRm10pMkJatG5',
		'rank': 'a0t'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': 'TDGnRLBGCRm10pMkJatG5',
		'value': 'Discount codes not applied when cart has mixed VAT rates',
		'id': 'bpSOkRaHuilbykf95VTQI',
		'fakeId': 'bpSOkRaHuilbykf95VTQI'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': 'TDGnRLBGCRm10pMkJatG5',
		'value': 'MM4PaUbjACqaR8uQSAB2S',
		'id': 'WOeZx9trh7Lhb04Rtyz7b',
		'fakeId': 'WOeZx9trh7Lhb04Rtyz7b',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': 'TDGnRLBGCRm10pMkJatG5',
		'value': '2026-05-11',
		'id': '54AsFpxsnMgHIBeOUNFGS',
		'fakeId': '54AsFpxsnMgHIBeOUNFGS'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': 'IC1JRODbHRPPRwdOkc5Tp',
		'fakeId': 'IC1JRODbHRPPRwdOkc5Tp',
		'rank': 'a1'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': 'IC1JRODbHRPPRwdOkc5Tp',
		'value': 'Simplify checkout from 5 steps → 3 steps',
		'id': 'siT1qD0ig_YMImYVBVHRT',
		'fakeId': 'siT1qD0ig_YMImYVBVHRT'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': 'IC1JRODbHRPPRwdOkc5Tp',
		'value': 'D0ygDBEeuwCgfN8wctWOS',
		'id': 'mod3dj7nkhtVlva5TP1-I',
		'fakeId': 'mod3dj7nkhtVlva5TP1-I',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': 'IC1JRODbHRPPRwdOkc5Tp',
		'value': '2026-05-10',
		'id': 'RWqo0kuUbWxr7Njh9mC4A',
		'fakeId': 'RWqo0kuUbWxr7Njh9mC4A'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': 'wIFgMlgWEVXqAZQxeDCDv',
		'fakeId': 'wIFgMlgWEVXqAZQxeDCDv',
		'rank': 'Zy'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': 'wIFgMlgWEVXqAZQxeDCDv',
		'value': 'Add filters for material type (wood, metal, concrete)',
		'id': 'ciZAeSFwNbi68Jhc6EWbM',
		'fakeId': 'ciZAeSFwNbi68Jhc6EWbM'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': 'wIFgMlgWEVXqAZQxeDCDv',
		'value': 'ImW3OpNTVFWadnV3Mh3X5',
		'id': '8smHTJIssUMyi0L35AbY9',
		'fakeId': '8smHTJIssUMyi0L35AbY9',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': 'wIFgMlgWEVXqAZQxeDCDv',
		'value': '2026-05-15',
		'id': '1dKPf2hjnZTi6gZoZVAxz',
		'fakeId': '1dKPf2hjnZTi6gZoZVAxz'
	},
	{
		'parentId': 'wIFgMlgWEVXqAZQxeDCDv',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'n6umKbiRaVdZmeovJhd2A',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'slug': 'category',
		'value': 'n3AlJcppyun2ntI9lA78E',
		'id': 'OEBJlmEWqkW1iw5YvsQOG',
		'fakeId': 'OEBJlmEWqkW1iw5YvsQOG'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': 'q2wWG4gvpMvtlpZZDCSHu',
		'fakeId': 'q2wWG4gvpMvtlpZZDCSHu',
		'rank': 'a0'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': 'q2wWG4gvpMvtlpZZDCSHu',
		'value': 'Search returns empty results for valid SKU codes',
		'id': 'GOHbzinrx0eRx2ERyW0d1',
		'fakeId': 'GOHbzinrx0eRx2ERyW0d1'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': 'q2wWG4gvpMvtlpZZDCSHu',
		'value': 'MM4PaUbjACqaR8uQSAB2S',
		'id': 'tpbMryuFSDsYuAJSK6KzA',
		'fakeId': 'tpbMryuFSDsYuAJSK6KzA',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': 'q2wWG4gvpMvtlpZZDCSHu',
		'value': '2026-05-01',
		'id': '5oOR5QcM_WZcGjM2iu8cT',
		'fakeId': '5oOR5QcM_WZcGjM2iu8cT'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': 'eoFVQMIL58MssuIWPcATD',
		'fakeId': 'eoFVQMIL58MssuIWPcATD',
		'rank': 'ZzV'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': 'eoFVQMIL58MssuIWPcATD',
		'value': 'Refactor search indexing job to reduce latency',
		'id': 'r_9V9wcT_H4hxDMLyYnfH',
		'fakeId': 'r_9V9wcT_H4hxDMLyYnfH'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': 'eoFVQMIL58MssuIWPcATD',
		'value': 'eOzYkc1LjQmlpogD4fA4w',
		'id': 'fZkPSo76p7Q81QY6uLJ1H',
		'fakeId': 'fZkPSo76p7Q81QY6uLJ1H',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': 'eoFVQMIL58MssuIWPcATD',
		'value': '2026-05-03',
		'id': 'pkQOp6I0H_s3n5_vv642a',
		'fakeId': 'pkQOp6I0H_s3n5_vv642a'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'id': 'lPOfHX_ZcNJjcvqrJZdog',
		'fakeId': 'lPOfHX_ZcNJjcvqrJZdog',
		'rank': 'Zz'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '-CPX86SrlnffwRzvpNgOq',
		'slug': 'do',
		'parentId': 'lPOfHX_ZcNJjcvqrJZdog',
		'value': 'Improve search result relevance for misspelled queries',
		'id': 'pPm2LiO-LlvtBE8BOY1zu',
		'fakeId': 'pPm2LiO-LlvtBE8BOY1zu'
	},
	{
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': '4CyekONzSuI33jhX4ZNtO',
		'slug': 'type',
		'parentId': 'lPOfHX_ZcNJjcvqrJZdog',
		'value': 'D0ygDBEeuwCgfN8wctWOS',
		'id': 'le89N8lCeA5jWLBB91TH-',
		'fakeId': 'le89N8lCeA5jWLBB91TH-',
		'targetRepositoryId': '331Xn2Ka-Od7-_68wFuUH'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'WQsZN24NG0FywPKlpcHU4',
		'slug': 'created-at',
		'parentId': 'lPOfHX_ZcNJjcvqrJZdog',
		'value': '2026-05-13',
		'id': 'f2VRHvb9F33By5Mu-kxqA',
		'fakeId': 'f2VRHvb9F33By5Mu-kxqA'
	},
	{
		'parentId': '8Y2vKdUkRTCLskHjUtSJw',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'n6umKbiRaVdZmeovJhd2A',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'slug': 'category',
		'value': '2OLoNhsUQUD6Ulx0pY0fx',
		'id': 'ZdgSiQFQCArn8Q34789fd',
		'fakeId': 'ZdgSiQFQCArn8Q34789fd'
	},
	{
		'parentId': 'IC1JRODbHRPPRwdOkc5Tp',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'n6umKbiRaVdZmeovJhd2A',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'slug': 'category',
		'value': 'hxufZmUPLlplIqJsDd56W',
		'id': 'UQAh68N-7TKOkxXn3QisZ',
		'fakeId': 'UQAh68N-7TKOkxXn3QisZ'
	},
	{
		'parentId': 'TDGnRLBGCRm10pMkJatG5',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'n6umKbiRaVdZmeovJhd2A',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'slug': 'category',
		'value': 'hxufZmUPLlplIqJsDd56W',
		'id': 'pzcLDBahlsCX1hqeACYzO',
		'fakeId': 'pzcLDBahlsCX1hqeACYzO'
	},
	{
		'parentId': 'DVlbwxLsBanZOdj5VA5A1',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'n6umKbiRaVdZmeovJhd2A',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'slug': 'category',
		'value': 'hxufZmUPLlplIqJsDd56W',
		'id': '_GqTIamGyTVh2Sgvtx6Zl',
		'fakeId': '_GqTIamGyTVh2Sgvtx6Zl'
	},
	{
		'parentId': 'eoFVQMIL58MssuIWPcATD',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'n6umKbiRaVdZmeovJhd2A',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'slug': 'category',
		'value': 'n3AlJcppyun2ntI9lA78E',
		'id': 'JloUCe0C93BvDxSzj4kCK',
		'fakeId': 'JloUCe0C93BvDxSzj4kCK'
	},
	{
		'parentId': 'q2wWG4gvpMvtlpZZDCSHu',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'n6umKbiRaVdZmeovJhd2A',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'slug': 'category',
		'value': 'n3AlJcppyun2ntI9lA78E',
		'id': 'mGKhb294bkZz3h30RjrNd',
		'fakeId': 'mGKhb294bkZz3h30RjrNd'
	},
	{
		'parentId': 'lPOfHX_ZcNJjcvqrJZdog',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'n6umKbiRaVdZmeovJhd2A',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'slug': 'category',
		'value': 'n3AlJcppyun2ntI9lA78E',
		'id': 'kYgIDJ2-qbdzdbU-NXyxp',
		'fakeId': 'kYgIDJ2-qbdzdbU-NXyxp'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryEntryId': 'DVlbwxLsBanZOdj5VA5A1',
		'xy': {
			'x': 627.7862410888191,
			'y': 494.34805390551855
		},
		'id': '-RZc8yFDFPlm4Q3hakaDz',
		'fakeId': '-RZc8yFDFPlm4Q3hakaDz',
		'anchorId': 'UvU44n5NCDoehzrk2kh0Y'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryEntryId': 'Z0VVznV7ithG9SWP80ZUj',
		'xy': {
			'x': 1228.390647181899,
			'y': 494.34805390551855
		},
		'id': 'lB_yyq1VMPAzRFcJ_w7n6',
		'fakeId': 'lB_yyq1VMPAzRFcJ_w7n6',
		'anchorId': 'UvU44n5NCDoehzrk2kh0Y'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryEntryId': '8Y2vKdUkRTCLskHjUtSJw',
		'xy': {
			'x': -238.28779005283155,
			'y': 191.06699824631457
		},
		'id': '58Zd8OgrgJPebcb9E_V0l',
		'fakeId': '58Zd8OgrgJPebcb9E_V0l',
		'anchorId': 'Ug6BtQeD8bu3vt8QP0meh'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryEntryId': 'knD5uUFeHsN52IX-2c5ls',
		'xy': {
			'x': 77.66779580318833,
			'y': 191.06699824631457
		},
		'id': 'n9Z0IiJs4N51x8wNww9ha',
		'fakeId': 'n9Z0IiJs4N51x8wNww9ha',
		'anchorId': 'Ug6BtQeD8bu3vt8QP0meh'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryEntryId': 'pZ0GZ5QmFzIn4bTuYjoxo',
		'xy': {
			'x': 1393.1558375735576,
			'y': 191.06699824631457
		},
		'id': 'NrdKV36WvCmocI4vLrAAE',
		'fakeId': 'NrdKV36WvCmocI4vLrAAE',
		'anchorId': 'Ug6BtQeD8bu3vt8QP0meh'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryEntryId': 'FwmIG5hDhRI-frXW68gHZ',
		'xy': {
			'x': 771.3725585657012,
			'y': -658.5982896120549
		},
		'id': '5Wu9WXoVKzLm6eXQ0xp4S',
		'fakeId': '5Wu9WXoVKzLm6eXQ0xp4S'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryEntryId': 'IC1JRODbHRPPRwdOkc5Tp',
		'xy': {
			'x': 928.6131997539329,
			'y': 494.34805390551855
		},
		'id': 'QXQoOMV5tnpqX3lUM9_tY',
		'fakeId': 'QXQoOMV5tnpqX3lUM9_tY',
		'anchorId': 'UvU44n5NCDoehzrk2kh0Y'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryEntryId': 'TDGnRLBGCRm10pMkJatG5',
		'xy': {
			'x': 1670.5162878142885,
			'y': 2489.235351595068
		},
		'id': '76LoE-mhEoJK0uOyLg-_c',
		'fakeId': '76LoE-mhEoJK0uOyLg-_c'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryEntryId': 'lPOfHX_ZcNJjcvqrJZdog',
		'xy': {
			'x': 1225.0698399963603,
			'y': -104.01696368558144
		},
		'id': 'SSBegilT4iCMzbN0VlvN7',
		'fakeId': 'SSBegilT4iCMzbN0VlvN7',
		'anchorId': 'C4sq-7lSmvrsI-0FvRfbE'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryEntryId': 'q2wWG4gvpMvtlpZZDCSHu',
		'xy': {
			'x': -225.50009352999035,
			'y': -104.01696368558144
		},
		'id': 'Ms8_Eo1li3Yrn-JZmvHVw',
		'fakeId': 'Ms8_Eo1li3Yrn-JZmvHVw',
		'anchorId': 'C4sq-7lSmvrsI-0FvRfbE'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryEntryId': 'wIFgMlgWEVXqAZQxeDCDv',
		'xy': {
			'x': 1566.770170303691,
			'y': -104.01696368558144
		},
		'id': 'KI7pU4asexwEbSZSctNRb',
		'fakeId': 'KI7pU4asexwEbSZSctNRb',
		'anchorId': 'C4sq-7lSmvrsI-0FvRfbE'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'repositoryEntryId': 'eoFVQMIL58MssuIWPcATD',
		'xy': {
			'x': 938.3566906256168,
			'y': -104.01696368558144
		},
		'id': 'EefqsYHGIXgS4xIcxVl7z',
		'fakeId': 'EefqsYHGIXgS4xIcxVl7z',
		'anchorId': 'C4sq-7lSmvrsI-0FvRfbE'
	},
	{
		'parentId': 'knD5uUFeHsN52IX-2c5ls',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'n6umKbiRaVdZmeovJhd2A',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'slug': 'category',
		'value': '2OLoNhsUQUD6Ulx0pY0fx',
		'id': 'qpgPoUbeqljk8cn4Txoyn',
		'fakeId': 'qpgPoUbeqljk8cn4Txoyn'
	},
	{
		'type': 'templatePropertyDate',
		'label': 'Shipped at',
		'slug': 'shipped-at',
		'required': false,
		'parentId': 'aB-zKTDZjDINyCLqhgdMK',
		'rank': 5,
		'id': 'QzM5sR1_go6Hk6ZDC586B',
		'fakeId': 'QzM5sR1_go6Hk6ZDC586B'
	},
	{
		'type': 'note',
		'title': 'This is your planning view — here you can place notes, data references and other elements that help you organize your data.  🤗',
		'parentId': null,
		'rank': 8,
		'xy': {
			'x': -964.7231359649132,
			'y': -732.449287280702
		},
		'id': 'Nat8Xe0iiYq3AQvyZs0Rz',
		'fakeId': 'Nat8Xe0iiYq3AQvyZs0Rz'
	},
	{
		'type': 'note',
		'title': 'You can even place notes within notes, and navigate through them...',
		'parentId': null,
		'rank': 9,
		'xy': {
			'x': -899.8184972574002,
			'y': -639.4298124119632
		},
		'id': 'DjouND17wW_1V14cpBLUp',
		'fakeId': 'DjouND17wW_1V14cpBLUp'
	},
	{
		'type': 'note',
		'title': 'Selected for dev',
		'variant': 'header',
		'parentId': null,
		'rank': 10,
		'xy': {
			'x': -235.37209302325644,
			'y': -374.2558139534888
		},
		'id': 'GoM5E3z-Wr1vQUpnP-ayK',
		'fakeId': 'GoM5E3z-Wr1vQUpnP-ayK'
	},
	{
		'type': 'repository',
		'title': 'Resources',
		'singular': 'Resource',
		'parentId': null,
		'rank': 11,
		'id': 'I1gfEksKkygPD4yQAAttB',
		'fakeId': 'I1gfEksKkygPD4yQAAttB',
		'isBookmarked': true,
		'color': '#6BCB77'
	},
	{
		'type': 'templatePropertyString',
		'parentId': 'I1gfEksKkygPD4yQAAttB',
		'label': 'Title',
		'slug': 'title',
		'required': false,
		'id': 'OLTAR8HMXN6tAum2-OGNO',
		'fakeId': 'OLTAR8HMXN6tAum2-OGNO',
		'rank': 0
	},
	{
		'type': 'templatePropertyString',
		'label': 'URL',
		'slug': 'url',
		'required': false,
		'parentId': 'I1gfEksKkygPD4yQAAttB',
		'rank': 1,
		'id': 'sO6M83Q7S0Q4beG8YPrWH',
		'fakeId': 'sO6M83Q7S0Q4beG8YPrWH'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 'I1gfEksKkygPD4yQAAttB',
		'repositoryId': 'I1gfEksKkygPD4yQAAttB',
		'id': '8CVF_1nPaQOkgrwtPsVaY',
		'fakeId': '8CVF_1nPaQOkgrwtPsVaY',
		'rank': 'a0'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'I1gfEksKkygPD4yQAAttB',
		'propertyDefinitionId': 'OLTAR8HMXN6tAum2-OGNO',
		'slug': 'title',
		'parentId': '8CVF_1nPaQOkgrwtPsVaY',
		'value': '[Reddit] what’s the best ai tool right now for ecommerce clothing brands?',
		'id': 'SLJgbKlYy8pdnw23wWkV7',
		'fakeId': 'SLJgbKlYy8pdnw23wWkV7'
	},
	{
		'type': 'entryPropertyString',
		'repositoryId': 'I1gfEksKkygPD4yQAAttB',
		'propertyDefinitionId': 'sO6M83Q7S0Q4beG8YPrWH',
		'slug': 'url',
		'parentId': '8CVF_1nPaQOkgrwtPsVaY',
		'value': 'https://www.reddit.com/r/ecommerce/comments/1tdxyfk/whats_the_best_ai_tool_right_now_for_ecommerce/',
		'id': 'PmFFmHmSLJ1P91gft-HU9',
		'fakeId': 'PmFFmHmSLJ1P91gft-HU9'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'I1gfEksKkygPD4yQAAttB',
		'repositoryEntryId': '8CVF_1nPaQOkgrwtPsVaY',
		'xy': {
			'x': -1113.9079157899744,
			'y': -129.32070279669307
		},
		'id': 'Q9stnq9_KoOjcEDwT4rN0',
		'fakeId': 'Q9stnq9_KoOjcEDwT4rN0'
	},
	{
		'type': 'templatePropertyDate',
		'label': 'From date',
		'slug': 'from-date',
		'required': true,
		'parentId': 'I1gfEksKkygPD4yQAAttB',
		'rank': 1,
		'id': 'wQPvhg24RNtN43UzOk40N',
		'fakeId': 'wQPvhg24RNtN43UzOk40N'
	},
	{
		'parentId': '8CVF_1nPaQOkgrwtPsVaY',
		'repositoryId': 'I1gfEksKkygPD4yQAAttB',
		'propertyDefinitionId': 'wQPvhg24RNtN43UzOk40N',
		'type': 'entryPropertyDate',
		'slug': 'from-date',
		'value': '2026-05-15',
		'id': '8zrq8TgeEUbGDCJIxDYJw',
		'fakeId': '8zrq8TgeEUbGDCJIxDYJw'
	},
	{
		'type': 'note',
		'title': 'Market data',
		'variant': 'header',
		'parentId': null,
		'rank': 11,
		'xy': {
			'x': -1042.2085732771568,
			'y': -386.76617506505625
		},
		'id': 'TIoNPM3CVIXwrhRQ3O-Pq',
		'fakeId': 'TIoNPM3CVIXwrhRQ3O-Pq'
	},
	{
		'type': 'note',
		'title': 'Uncategorized',
		'variant': 'header',
		'parentId': null,
		'rank': 12,
		'xy': {
			'x': 772.7699099039064,
			'y': -842.1324152020993
		},
		'id': 'oOHPwYl3POEXq6A7Yn4gn',
		'fakeId': 'oOHPwYl3POEXq6A7Yn4gn'
	},
	{
		'type': 'chart',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'rank': 13,
		'title': 'Work items created / 8w',
		'where': null,
		'includeArchived': true,
		'metric': '__count__',
		'xAxis': 'created-at',
		'xAxisTimeScale': null,
		'targetA': null,
		'targetB': null,
		'xy': {
			'x': -391.9661364298815,
			'y': -648.3085278206648
		},
		'id': 'ZcQIcLqe9KkAUxXyGywCu',
		'fakeId': 'ZcQIcLqe9KkAUxXyGywCu',
		'variant': 'heatmap'
	},
	{
		'parentId': 'q2wWG4gvpMvtlpZZDCSHu',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'QzM5sR1_go6Hk6ZDC586B',
		'type': 'entryPropertyDate',
		'slug': 'shipped-at',
		'value': '2026-05-14',
		'id': 'lOCC5dcgYNLcIGk-rhK6D',
		'fakeId': 'lOCC5dcgYNLcIGk-rhK6D'
	},
	{
		'type': 'note',
		'title': 'Stats',
		'variant': 'header',
		'parentId': null,
		'rank': 13,
		'xy': {
			'x': -393.464215379433,
			'y': -804.9563782344118
		},
		'id': 'P1rIUOtE40372tvvj467L',
		'fakeId': 'P1rIUOtE40372tvvj467L'
	},
	{
		'parentId': 'pZ0GZ5QmFzIn4bTuYjoxo',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'n6umKbiRaVdZmeovJhd2A',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'slug': 'category',
		'value': '2OLoNhsUQUD6Ulx0pY0fx',
		'id': 'ap3qv5xXyagn8v0e-XWA7',
		'fakeId': 'ap3qv5xXyagn8v0e-XWA7'
	},
	{
		'parentId': 'Z0VVznV7ithG9SWP80ZUj',
		'type': 'entryPropertyBelongsTo',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyDefinitionId': 'n6umKbiRaVdZmeovJhd2A',
		'targetRepositoryId': 'geg-qOCWjoSskQhNU72FS',
		'slug': 'category',
		'value': 'hxufZmUPLlplIqJsDd56W',
		'id': '4IWi7EvoO5NrUzlvgBNT0',
		'fakeId': '4IWi7EvoO5NrUzlvgBNT0'
	},
	{
		'type': 'anchor',
		'parentId': null,
		'repositoryId': 'geg-qOCWjoSskQhNU72FS',
		'referenceId': null,
		'direction': 'vertical',
		'xy': {
			'x': -614.7729876423635,
			'y': -286.57937276322116
		},
		'id': 'ieXV9hCevuRsUtKHByd2d',
		'fakeId': 'ieXV9hCevuRsUtKHByd2d'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'geg-qOCWjoSskQhNU72FS',
		'repositoryEntryId': '2OLoNhsUQUD6Ulx0pY0fx',
		'xy': {
			'x': -614.7729876423635,
			'y': 191.06699824631457
		},
		'id': 'aR3etaUQMCvB7rYI0TTeI',
		'fakeId': 'aR3etaUQMCvB7rYI0TTeI',
		'anchorId': 'ieXV9hCevuRsUtKHByd2d'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'geg-qOCWjoSskQhNU72FS',
		'repositoryEntryId': 'hxufZmUPLlplIqJsDd56W',
		'xy': {
			'x': -614.7729876423635,
			'y': 494.34805390551855
		},
		'id': 'Bw_P975PqGujX1AZ8HwuZ',
		'fakeId': 'Bw_P975PqGujX1AZ8HwuZ',
		'anchorId': 'ieXV9hCevuRsUtKHByd2d'
	},
	{
		'type': 'resource',
		'parentId': null,
		'repositoryId': 'geg-qOCWjoSskQhNU72FS',
		'repositoryEntryId': 'n3AlJcppyun2ntI9lA78E',
		'xy': {
			'x': -614.7729876423635,
			'y': -104.01696368558144
		},
		'id': '4o3rAMZRK-Wcf8giEDfzE',
		'fakeId': '4o3rAMZRK-Wcf8giEDfzE',
		'anchorId': 'ieXV9hCevuRsUtKHByd2d'
	},
	{
		'type': 'anchor',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'referenceId': 'aR3etaUQMCvB7rYI0TTeI',
		'direction': 'horizontal',
		'xy': {
			'x': -477.1366735009058,
			'y': 688.8670887462035
		},
		'id': 'Ug6BtQeD8bu3vt8QP0meh',
		'fakeId': 'Ug6BtQeD8bu3vt8QP0meh'
	},
	{
		'type': 'anchor',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'referenceId': 'Bw_P975PqGujX1AZ8HwuZ',
		'direction': 'horizontal',
		'xy': {
			'x': -477.1366735009058,
			'y': 677.0244464887409
		},
		'id': 'UvU44n5NCDoehzrk2kh0Y',
		'fakeId': 'UvU44n5NCDoehzrk2kh0Y'
	},
	{
		'type': 'anchor',
		'parentId': null,
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'referenceId': '4o3rAMZRK-Wcf8giEDfzE',
		'direction': 'horizontal',
		'xy': {
			'x': -477.1366735009058,
			'y': 680.6364254254185
		},
		'id': 'C4sq-7lSmvrsI-0FvRfbE',
		'fakeId': 'C4sq-7lSmvrsI-0FvRfbE'
	},
	{
		'type': 'anchorEffectAssignValue',
		'parentId': null,
		'anchorId': 'Ug6BtQeD8bu3vt8QP0meh',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyId': 'n6umKbiRaVdZmeovJhd2A',
		'value': '2OLoNhsUQUD6Ulx0pY0fx',
		'id': 'yKrp0v0G7RG5vX3vN2sVv',
		'fakeId': 'yKrp0v0G7RG5vX3vN2sVv'
	},
	{
		'type': 'anchorEffectAssignValue',
		'parentId': null,
		'anchorId': 'UvU44n5NCDoehzrk2kh0Y',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyId': 'n6umKbiRaVdZmeovJhd2A',
		'value': 'hxufZmUPLlplIqJsDd56W',
		'id': 'D0jPQe0X9m9xEwq2vQOe7',
		'fakeId': 'D0jPQe0X9m9xEwq2vQOe7'
	},
	{
		'type': 'anchorEffectAssignValue',
		'parentId': null,
		'anchorId': 'C4sq-7lSmvrsI-0FvRfbE',
		'repositoryId': 'aB-zKTDZjDINyCLqhgdMK',
		'propertyId': 'n6umKbiRaVdZmeovJhd2A',
		'value': 'n3AlJcppyun2ntI9lA78E',
		'id': 'j7bYQvV0K0hZ1r2fQe6xT',
		'fakeId': 'j7bYQvV0K0hZ1r2fQe6xT'
	}
];